import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './HeroSection.css';
import heroImg from '../images/welcome-home-healthcare.jpg';

const HeroSection = () => {
  return (
    <section className="hero-section" id="home">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="hero-image-col">
            <div className="hero-image">
              <img src={heroImg} alt="Home care" />
            </div>
          </Col>
          <Col lg={6} className="hero-content">
            <p className="hero-top">Welcome To Aroghya Radham Home Care</p>
            <h1 className="hero-title">Best Home Care Services</h1>
            <p className="hero-description">
              At Aroghya Radham Home Care, we understand the challenges of managing health conditions and the importance of receiving home care services
              that provide quality care in the comfort of your own home. We're committed to delivering personalized,
              compassionate, high-quality services tailored to each client's needs. Our team of experienced nurses,
              physiotherapists, doctors and support staff ensure every patient receives the best possible care.
            </p>

            <div className="hero-features">
              <div className="feature-item">
                <div className="feature-icon" aria-hidden>
                  {/* clock SVG with rotating hand */}
                  <svg width="28" height="28" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                    {/* longer/thicker hour hand */}
                    <line x1="12" y1="12" x2="12" y2="6" stroke="white" strokeWidth="2" strokeLinecap="round" />
                    {/* longer/thicker rotating minute hand */}
                    <line className="clock-hand" x1="12" y1="12" x2="19" y2="12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                    {/* center cap */}
                    <circle cx="12" cy="12" r="0.9" fill="white" />
                  </svg>
                </div>
                <div className="feature-text">
                  <h4>24/7 support:</h4>
                  <p>We are here for you at any time, ensuring peace of mind for families.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon" aria-hidden>
                  {/* user SVG */}
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 21v-2a4 4 0 0 0-3-3.87M4 21v-2a4 4 0 0 1 3-3.87M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" stroke="#fff" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="feature-text">
                  <h4>Experienced Caregivers</h4>
                  <p>Our team is trained, certified, and passionate about care.</p>
                </div>
              </div>
            </div>

            <div className="hero-actions">
              <Button as={Link} to="/contact" className="btn-contact me-3" size="lg">Contact Us</Button>
              <Button as={Link} to="/about" variant="link" className="about-link">About Us <span className="arrow">→</span></Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
